<script>
import FormModel from "@/views/Recruitment/Planning/Components/FormModel.vue"

export default {
    components: {FormModel},
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        lockAction: Boolean,
    },
}
</script>

<template>
    <div>
        <FormModel
            :add-action="addAction"
            :update-action="updateAction"
            :delete-action="deleteAction"
            :view-action="viewAction"
            :lock-action="lockAction"
            type="EVALUATION"
        />
    </div>
</template>